import * as React from 'react';
import FormInput from '../../../common/form/Input';
import FormPhoneInput from '../../../common/form/PhoneInput';
import Form from '../../../common/form/Form';
import Button from '../../../common/form/Button';
import { PropertyInfo, TimeZone, getIntegrationTypes, syncPropertyUnitsWithPms } from '../../../../api/Property';
import FormSelectLabeled from '../../../common/form/SelectLabeled';
import FormDatePicker from '../../../common/form/DatePicker';
import * as moment from 'moment';
import { momentDateFormat } from '../../../../utilities/formatting';
import FormValidationDisplay from '../../../common/form/ValidationDisplay';
import { StartDay } from '../../../../utilities/Enums';
import { userIsSystemAdmin } from '../../../../utilities/identity';
import ProspectMessagesConfigurationSection from './ProspectMessagesConfigurationSection';
import CheckboxLabeled from '../../../common/form/CheckboxLabeled';
import CollapsibleCard from '../../../common/CollapsibleCard';
import * as identity from './../../../../utilities/identity';
import { Roles } from './../../../../utilities/Enums';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { useEffect, useState } from 'react';
import { LoadingDisplay } from '../../../common/LoadingOverlay';
import { Modal, ModalBody } from 'reactstrap';
import { AdvancedConfiguration } from '../../../../api/PropertyIntegration';
import PropertyScanner from './PropertyScanner';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import FormInputWithButton from '../../../common/form/InputWithButton';
import {userIsCompanyManageUser,userIsPropertyManageUser,userIsSystemManageUser} from '../../../../utilities/identity';

interface Props extends PropertyInfo {
    id: number;
    advancedConfiguration?: AdvancedConfiguration;
    slug: string;
    onChange: (inputName: string, newValue: string | number | boolean | undefined) => void;
    onSubmit: () => void;
    onFormValidated: () => void;
    onPropertyDelete?: () => void;
    wasFormValidated: boolean;
    newProperty: boolean;
    availableTimeZones?: TimeZone[];
    errorMessage?: string;
    additionalTopContent?: JSX.Element;
}

const PropertyInfoForm = (props: Props) => {
    const role = identity.getMyRole();
    const canSeeManage = role === Roles.SystemAdmin;
     const isUser = (
            userIsCompanyManageUser() ||
            userIsPropertyManageUser() ||
            userIsSystemManageUser()
        );

    const [unitManagementTypes, setUnitManagementTypes] = useState(props.unitManagementTypes)
    const [leaseForwardingTypes, setLeaseForwardingTypes] = useState(props.leadForwardingTypes)
    const [unitSync, setUnitSync] = useState<any>({});
    const [unitSyncLoading, setUnitSyncLoading] = useState(false);
    const [showPropertyScanner, setShowPropertyScanner] = useState(false);

    const getIntegrations = async () => {
        if((unitManagementTypes && unitManagementTypes.length ==0) && (leaseForwardingTypes && leaseForwardingTypes.length==0)){
            let result = await getIntegrationTypes();
            if (result.success && result.data) {
                props.onChange('unitManagementTypes', result.data['unitManagementTypes'])
                props.onChange('leadForwardTypes', result.data['leadForwardTypes'])
                const unitTypesList = (result.data['unitManagementTypes']!=undefined? result.data['unitManagementTypes']:[])
                const unitTypes = [{
                    id: 0,
                    name: 'None',
                    beaconUuid: '0'
                },...unitTypesList]
                setUnitManagementTypes(unitTypes)
                const leaseTypesList = (result.data['leadForwardTypes']!=undefined? result.data['leadForwardTypes']:[])
                const leaseTypes = [{
                    id: 0,
                    name: 'None',
                    beaconUuid: '0'
                },...leaseTypesList]
                setLeaseForwardingTypes(leaseTypes)
            }
        }else {

            const unitTypesList = (unitManagementTypes!=undefined? unitManagementTypes:[])
            const unitTypes = [{
                id: 0,
                name: 'None',
                beaconUuid: '0'
            },...unitTypesList]
            setUnitManagementTypes(unitTypes)

            const leaseTypesList = (leaseForwardingTypes!=undefined? leaseForwardingTypes:[])
            const leaseTypes = [{
                id: 0,
                name: 'None',
                beaconUuid: '0'
            },...leaseTypesList]
            setLeaseForwardingTypes(leaseTypes)
        }
    };
    async function parsePropertyUnitsSync(result: any) {
        const pattern = /Units Added:\s*(\d+)/;
        const matches = result.data.match(pattern);
        if(matches){
            result.unitsAdded = parseInt(matches[1], 10);
        }
        return result;
    }
    const handleClick = () => {
        setUnitSyncLoading(true);
        syncPropertyUnitsWithPms(props.id).then(async result => {
            if (result.success && result.data) {
                const parsedRes: any = await parsePropertyUnitsSync(result);
                setUnitSyncLoading(false);
                setUnitSync(parsedRes);
            }
            else {
                setUnitSyncLoading(false);
                setUnitSync(result);

            }
        });
    }
    function shouldDisableButton() {
        const { enableUnitManagement, unitManagementId, advancedConfiguration } = props;
        if (!enableUnitManagement || !advancedConfiguration || !unitManagementId ||  unitManagementId === 0) return true;
        const { entrataConfiguration, yardiConfiguration, oneSiteConfiguration } = advancedConfiguration;
        if (
            (unitManagementId === 1 && (entrataConfiguration === undefined || entrataConfiguration === null)) ||
            (unitManagementId === 2 && (yardiConfiguration === undefined || yardiConfiguration === null)) ||
            (unitManagementId === 3 && (oneSiteConfiguration === undefined || oneSiteConfiguration === null))
        ) {
            return true;
        }
    
        return false;
    }
    

    useEffect(() => {
        getIntegrations();
    }, []);

    return (
        <>
            {props.additionalTopContent && (
                <div className="row">
                    <div className="col">{props.additionalTopContent}</div>
                </div>
            )}

<Modal isOpen={unitSync !== null && Object.keys(unitSync).length > 0}>
                <ModalBody>
        {unitSyncLoading ? (
            <LoadingDisplay />
        ) : (
            <div>
                {unitSync.success && unitSync.unitsAdded ? (
                    <React.Fragment>
                        <p> No of Units Added <b>{unitSync.unitsAdded}</b></p>
                    </React.Fragment>
                ): unitSync.success && !unitSync.unitsAdded ? (
                    <React.Fragment>
                        <p>{unitSync.data}</p>
                    </React.Fragment>
                )  : (
                    <p>{unitSync.error}</p>
                )}
                <div className="deletion-popup-buttons">
                    <Button
                        text="Ok"
                        onClick={() => setUnitSync({})}
                        addlClassName="deletion-cancel"
                        suppressBottomMargin={true}
                    />
                </div>
            </div>
        )}
                </ModalBody>
            </Modal>

            <Form
                wasFormValidated={props.wasFormValidated}
                inBootstrapColumn={true}
                submitButtonText={props.newProperty ? 'Create Property' : 'Update Property Info'}
                onSubmit={props.onSubmit}
                onFormValidated={props.onFormValidated}
                additionalButtons={
                    !props.newProperty &&
                    userIsSystemAdmin() &&
                    props.onPropertyDelete && (
                        <Button
                            text="Delete Property"
                            addlClassName="btn-danger"
                            onClick={props.onPropertyDelete}
                            disabled={isUser}
                        />
                    )
                }
                disabled={isUser}
            >
                <FormValidationDisplay errorMessage={props.errorMessage} />
                <div className="card info-card">
                    <div className="card-body">
                        <FormInput
                            inputProps={{
                                id: 'salesforcePropertyId',
                                name: 'salesforcePropertyId',
                                value: props.salesforcePropertyId,
                                required: false,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Salesforce Property ID',
                                invalidText: 'Please enter a Salesforce Property ID'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'name',
                                name: 'name',
                                value: props.name,
                                required: true,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Property Name',
                                invalidText: 'Please enter a property name'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'street-address',
                                name: 'streetAddress',
                                value: props.streetAddress,
                                required: true,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Street Address',
                                invalidText: 'Please enter a street address'
                            }}
                            onChange={props.onChange}
                        />
                        <div className="row">
                            <FormInput
                                inputProps={{
                                    id: 'city',
                                    name: 'city',
                                    value: props.city,
                                    required: true,
                                    readOnly: isUser,
                                }}
                                labelProps={{
                                    labelText: 'City',
                                    invalidText:
                                        'Please enter the name of the city where the property is located'
                                }}
                                onChange={props.onChange}
                                controlCssClass="col-6"
                            />
                            <FormInput
                                inputProps={{
                                    id: 'state',
                                    name: 'state',
                                    value: props.state,
                                    required: true,
                                    maxLength: 2,
                                    minLength: 2,
                                    readOnly: isUser,
                                }}
                                labelProps={{
                                    labelText: 'State',
                                    invalidText: 'Please enter the state code for the property'
                                }}
                                onChange={props.onChange}
                                controlCssClass="col-2"
                            />
                            <FormInput
                                inputProps={{
                                    id: 'zip',
                                    name: 'zip',
                                    value: props.zip,
                                    required: true,
                                    minLength: 5,
                                    readOnly: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Zip Code',
                                    invalidText: 'Please enter the zip code for the property'
                                }}
                                onChange={props.onChange}
                                controlCssClass="col-4"
                            />
                        </div>
                        <div className="row">
                            <FormInput
                                inputProps={{
                                    id: 'latitude',
                                    name: 'latitude',
                                    value: props.latitude,
                                    required: true,
                                    pattern: '[-+]?[0-9]*[.,]?[0-9]+',
                                    readOnly: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Latitude',
                                    invalidText: 'Please enter the latitude for the property'
                                }}
                                onChange={props.onChange}
                                controlCssClass="col-6"
                            />
                            <FormInput
                                inputProps={{
                                    id: 'longitude',
                                    name: 'longitude',
                                    value: props.longitude,
                                    required: true,
                                    pattern: '[-+]?[0-9]*[.,]?[0-9]+',
                                    readOnly: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Longitude',
                                    invalidText: 'Please enter the longitude for the property'
                                }}
                                onChange={props.onChange}
                                controlCssClass="col-6"
                            />
                        </div>
                        <FormSelectLabeled
                            selectProps={{
                                id: 'time-zone-id',
                                name: 'timeZoneId',
                                value: props.timeZoneId,
                                required: true,
                                disabled: isUser,
                            }}
                            selectOptions={
                                props.availableTimeZones
                                    ? props.availableTimeZones.map(timeZone => ({
                                        value: timeZone.timeZoneId,
                                        label: timeZone.displayName
                                    }))
                                    : []
                            }
                            labelProps={{
                                labelText: 'Time Zone',
                                invalidText: 'Please select a time zone'
                            }}
                            onChange={props.onChange}
                        />

                        <FormInput
                            inputProps={{
                                id: 'contact-email',
                                name: 'contactEmail',
                                value: props.contactEmail,
                                required: true,
                                type: 'email',
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Contact Email',
                                invalidText: 'Please enter a valid email address'
                            }}
                            onChange={props.onChange}
                        />
                        <FormPhoneInput
                            inputProps={{
                                id: 'contact-phone',
                                name: 'contactPhone',
                                value: props.contactPhone,
                                required: true,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Contact Phone'
                            }}
                            onChange={props.onChange}
                        />
                       { props.newProperty ? <FormInput
                            inputProps={{
                                id: 'slug',
                                name: 'slug',
                                value: props.slug,
                                required: true,
                                pattern: '[-a-z0-9]+',
                                disabled: !props.newProperty || isUser,
                            }}
                            labelProps={{
                                labelText: 'Property URL Extension',
                                invalidText:
                                    'Please enter a lowercase URL extension with dashes instead of spaces'
                            }}
                            onChange={props.onChange}
                        /> : <FormInputWithButton
                            inputProps={{
                                id: 'slug',
                                name: 'slug',
                                value: props.slug,
                                required: true,
                                pattern: '[-a-z0-9]+',
                                disabled: !props.newProperty,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Property URL Extension',
                                invalidText:
                                    'Please enter a lowercase URL extension with dashes instead of spaces'
                            }}
                            onChange={props.onChange}
                            setShowPropertyScanner={setShowPropertyScanner}
                        />}
                        <FormInput
                            inputProps={{
                                id: 'image-url',
                                name: 'propertyImage',
                                value: props.propertyImage || '',
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Image URL'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'leasing-url',
                                name: 'leasingUrl',
                                value: props.leasingUrl || '',
                                pattern: '^https?://.+',
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Leasing URL',
                                invalidText:
                                    'Please include http:// or https:// at the beginning of the URL'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'terms-link',
                                name: 'termsLink',
                                value: props.termsLink || '',
                                maxLength: 2000,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Terms & Conditions Link'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'map-link',
                                name: 'mapLink',
                                value: props.mapLink || '',
                                maxLength: 2000,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Property Map Image URL'
                            }}
                            onChange={props.onChange}
                        />
                        <FormInput
                            inputProps={{
                                id: 'tour-page-image-url',
                                name: 'tourPageImageURL',
                                value: props.tourPageImageURL || '',
                                maxLength: 2000,
                                readOnly: isUser,
                            }}
                            labelProps={{
                                labelText: 'Property image to show on web-based tour page'
                            }}
                            onChange={props.onChange}
                        />
                        <FormDatePicker
                            labelProps={{
                                labelText: 'Go Live Date',
                                invalidText: 'Please select a valid date'
                            }}
                            inputProps={{
                                value: moment(props.goLiveDate).format(momentDateFormat),
                                id: 'go-live-date',
                                name: 'goLiveDate',
                                required: true,
                                allowAllDates: true,
                                disabled: isUser,
                            }}
                            onChange={props.onChange}
                        />
                         <FormSelectLabeled
                                selectProps={{
                                    id: 'max-tour-schedule',
                                    name: 'maxTourScheduleCountsPerDay',
                                    value: props.maxTourScheduleCountsPerDay,
                                    disabled: isUser,
                                }}
                                labelProps={{
                                    labelText: 'MAXIMUM NUMBER OF TOURS PER DAY'
                                }}
                                selectOptions={Array.from({ length: 10 }, (v, k) => ({
                                    value: k + 1,
                                    label: (k + 1).toString()
                                }))}
                                onChange={props.onChange}
                            />
                        <div className="row">
                            <FormSelectLabeled
                                selectProps={{
                                    id: 'request-pet-information',
                                    name: 'requestPetInformation',
                                    value: props.requestPetInformation,
                                    disabled: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Request Pet Information'
                                }}
                                selectOptions={[
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' }
                                ]}
                                onChange={props.onChange}
                                className="col-6"
                            />
                            <FormSelectLabeled
                                selectProps={{
                                    id: 'request-credit-card',
                                    name: 'requestCreditCard',
                                    value: props.requestCreditCard,
                                    disabled: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Request Credit Card'
                                }}
                                selectOptions={[
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' }
                                ]}
                                onChange={props.onChange}
                                className="col-6"
                            />
                        </div>
                        {props.requestPetInformation && (
                            <div className="row">
                                <FormInput
                                    inputProps={{
                                        id: 'pet-Policy',
                                        name: 'petPolicy',
                                        value: props.petPolicy || '',
                                        maxLength: 100,
                                        required: props.requestPetInformation,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: 'Pet Policy'
                                    }}
                                    onChange={props.onChange}
                                    controlCssClass="col-12"
                                />
                            </div>
                        )}
                        <div className="row">
                            <FormSelectLabeled
                                selectProps={{
                                    id: 'request-desired-lease-length',
                                    name: 'requestDesiredLeaseLength',
                                    value: props.requestDesiredLeaseLength,
                                    disabled: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Request Desired Lease Length'
                                }}
                                selectOptions={[
                                    { value: true, label: 'Yes' },
                                    { value: false, label: 'No' }
                                ]}
                                onChange={props.onChange}
                                className="col-6"
                            />
                            <FormSelectLabeled
                                selectProps={{
                                    id: 'prospect-stats-start-day',
                                    name: 'startDay',
                                    value: props.startDay,
                                    disabled: isUser,
                                }}
                                labelProps={{
                                    labelText: 'Start Day for Prospect Stats Reports'
                                }}
                                selectOptions={[
                                    { value: StartDay.Sunday, label: 'Sunday' },
                                    { value: StartDay.Monday, label: 'Monday' },
                                    { value: StartDay.Tuesday, label: 'Tuesday' },
                                    { value: StartDay.Wednesday, label: 'Wednesday' },
                                    { value: StartDay.Thursday, label: 'Thursday' },
                                    { value: StartDay.Friday, label: 'Friday' },
                                    { value: StartDay.Saturday, label: 'Saturday' }
                                ]}
                                onChange={props.onChange}
                                className="col-6"
                            />
                        </div>
                        {userIsSystemAdmin() && (
                            <ProspectMessagesConfigurationSection
                                isMobileRedirect={props.isMobileRedirect}
                                onChangeMobileRedirect={(newValue: boolean) =>
                                    props.onChange('isMobileRedirect', newValue)
                                }
                                messagesSuppressionsValue={props.prospectMessagesSuppressions}
                                onChange={newValue =>
                                    props.onChange('prospectMessagesSuppressions', newValue)
                                }
                                disabled={isUser}
                            />
                        )}
                        <Row>
                            <Col>
                                <CheckboxLabeled
                                    labelProps={{
                                        labelText: 'Send No-Show Emails to Property?'
                                    }}
                                    inputProps={{
                                        id: 'send-no-show-messages-to-property',
                                        name: 'sendNoShowMessagesToProperty',
                                        checked: props.sendNoShowMessagesToProperty,
                                        disabled: isUser,
                                    }}
                                    onChange={props.onChange}
                                />
                            </Col>
                            {userIsSystemAdmin() && (
                                <Col>
                                    <CheckboxLabeled
                                        labelProps={{ labelText: 'Hide from Searches' }}
                                        inputProps={{
                                            id: 'hide-from-searches',
                                            name: 'hideFromSearches',
                                            checked: props.hideFromSearches,
                                            disabled: isUser,
                                        }}
                                        onChange={props.onChange}
                                    />
                                </Col>
                            )}
                        </Row>

                        <Row>
                        {userIsSystemAdmin() && (
                            <Col>
                                <CheckboxLabeled
                                    labelProps={{
                                        labelText: 'Warm Leads'
                                    }}
                                    inputProps={{
                                        id: 'warm-leads',
                                        name: 'warmLeadsStatus',
                                        checked: props.warmLeadsStatus,
                                        disabled: isUser,
                                    }}
                                    onChange={props.onChange}   
                                />
                            </Col>
                        )}
                        </Row>
                    
                    </div>
                </div>
                
                {canSeeManage && <div className="card config-card">
                    <div className="card-header">
                        <div className="row">
                            <div className="font-weight-bold col">Lead Management</div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Row>
                             <Col>
                                <FormSelectLabeled
                                    selectProps={{
                                        id: 'lease-forwarding',
                                        name: 'moveCompany',
                                        value: props.leadForwardingId,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: 'Lead Forwarding'
                                    }}
                                    selectOptions={
                                        leaseForwardingTypes === undefined
                                            ? []
                                            : leaseForwardingTypes
                                                .map(c => ({ value: c.id, label: c.name }))
                                    }
                                    onChange={(_name, value) =>
                                      props.onChange('leadForwardingId', value)
                                    }
                                />
                             </Col>
                             <Col></Col>
                        </Row>
                    </div>
                </div>}
                {canSeeManage && (
                    <CollapsibleCard
                        cardTitle="Unit Management"
                        cardOpen={!!props.enableUnitManagement}
                        onCardOpenChange={newValue => {
                            props.onChange('enableUnitManagement', newValue);
                        }}
                        isDisabled={isUser}
                    >
                     <div>
                        <Row>
                                <Col>
                                    <FormSelectLabeled
                                        selectProps={{
                                            id: 'request-sync-Property-units-Availability',
                                            name: 'syncPropertyUnitsAvailability',
                                            value: props.syncPropertyUnitsAvailability,
                                            disabled: isUser,
                                        }}
                                        labelProps={{
                                            labelText: 'Enable PMS Availability',
                                            invalidText: 'Select Enable PMS Availability'
                                        }}
                                        selectOptions={[
                                            { value: true, label: 'Yes' },
                                            { value: false, label: 'No' }
                                        ]}
                                        onChange={props.onChange}
                                    />
                                </Col>
                               <Col>
                                <FormInput
                                    inputProps={{
                                        id: 'beacon-uuid',
                                        name: 'beaconUuid',
                                        value: props.beaconUuid || '',
                                        maxLength: 100,
                                        required: false,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: 'Beacon UUID'
                                    }}
                                    onChange={props.onChange}
                                />
                              </Col>
                        </Row>
                        <Row>
                             <Col>
                                <FormSelectLabeled
                                    selectProps={{
                                        id: 'unit-management-type',
                                        name: 'unitManagementType',
                                        value: props.unitManagementId,
                                        disabled: isUser,
                                    }}
                                    labelProps={{
                                        labelText: 'Unit Management Integration'
                                    }}
                                    selectOptions={
                                        unitManagementTypes === undefined
                                            ? []
                                            : unitManagementTypes
                                                .map(c => ({ value: c.id, label: c.name }))
                                    }
                                    onChange={(_name, value) =>
                                        props.onChange('unitManagementId', value)
                                    }
                                />
                             </Col>
                             <Col>
                             <button type='button' disabled={shouldDisableButton()  || isUser} className="load-unit-admin btn-primary btn font-weight-bold" onClick={handleClick}>
                             Load Units
                            </button>
                            {unitSyncLoading && <span className="spinner-button-load-units"></span>}
                             </Col>
                        </Row>
                      </div>
                    </CollapsibleCard>
                )}
            </Form>
            <Modal isOpen={showPropertyScanner}>
                <ModalHeader
                 toggle={()=>{
                    setShowPropertyScanner(false)
                 }}>QR Code</ModalHeader>
                <ModalBody>
                {!isUser ? (
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', margin: '50px' }}>
                        <PropertyScanner propertyExtension={props.slug} setShowPropertyScanner={setShowPropertyScanner} />
                    </div>
                    ) : (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                        You do not have permission to access this feature.
                    </div>
                )}
                </ModalBody>
            </Modal>
 
        </>
    );
};

export default PropertyInfoForm;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/PropertyInfoForm.tsx